<template>
	<div class="app_header_container">

		<header class="app_header">
			<div class="container">
				<div class="row">
					<div class="col-2">
						<div class="icon_container"
						@click="toggle_mobile_nav"
						>
							<font-awesome-icon icon="bars"></font-awesome-icon>
						</div>
					</div>
					<div class="col-8">
						<div class="logo_container">
							<a href="/"
							@click="goto_path('/', $event)"
							>
								<img src="../assets/dayton-dotcom-logo.png" alt="">
							</a>
						</div>
					</div>
					<div class="col-2">
						<div class="icon_container" @click="toggle_search"
						v-show="(instance_period == 'Nomination Period' || instance_period == 'Voting Period')"
						>
							<font-awesome-icon icon="search"></font-awesome-icon>
						</div>
					</div>
				</div>
			</div>
		</header>

		<transition
		enter-active-class="animated flipInX faster" 
		leave-active-class="animated flipOutX faster"
		>

			<search-box
			v-if="show_search && (instance_period == 'Nomination Period' || instance_period == 'Voting Period')"
			:contest_list="master_contest_list"
			@search_hit="handle_search"
			></search-box>

		</transition>
		
		<h1 class="app_title">{{app_label}}</h1>
	
		<dev-period-sim
		v-if="env == 'development'"
		></dev-period-sim>

	</div>
</template>

<script>
import router from '@/router';
import SearchBox from '@/components/search/search_box.vue';
import DevPeriodSim from '@/components/dev_tools/dev_period_simulator'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faBars, faSearch);

export default {
	name: 'AppHeader',
	props: [
		'app_label'
	],
	data () {
		return {
			show_search: false,
			env: this.$root.state.env
		}
	},
	computed: {
		instance_period: function() {
			return this.$root.store.instances.get_current_active_instance_period();
		},
		master_contest_list: function() {
			return this.$root.store.contests.get_current_master_contest_list();
		}
	},
	methods: {
		goto_path: function(path_name, e) {
			e.preventDefault();
			
			this.$root.store.goto_path(path_name);
		},
		toggle_mobile_nav: function() {
			console.log('toggling nav: ');
			this.$root.store.nav.toggle_mobile_nav();
		},
		toggle_search: function() {
			this.show_search = !this.show_search;
		},
		handle_search: function(search_for) {
			let vm = this;
			vm.toggle_search();

			if(vm.instance_period == 'Nomination Period') {
				this.$root.store.goto_path('/nominate', search_for.instance_contestid);
			}
			else if(vm.instance_period == 'Voting Period') {
				this.$root.store.goto_path('/votenow/', search_for.instance_contestid);
			}
		}
	},
	components: {
		SearchBox,
		DevPeriodSim
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';
@import url('https://fonts.googleapis.com/css?family=Pathway+Gothic+One');

.app_header_container {
	margin-top: 3.52rem;

	.search_box_container {
		position: fixed;
		top: 59px;
		left: 0;
		box-shadow: 1px 1px 5px #333;
	}
}

h1 {
	margin-top: 0.5em;
	font-size: 2em;
	text-align: center;
	font-family: 'Pathway Gothic One', sans-serif;
	background: $dcom-orange;
	color: #FFF;
	font-weight: bold;
	/*padding: 0.5em;*/
}

h3 {
	font-size: 1.5rem;
}

/* nav {

	a {
	display: inline-block;
	padding: 0.25em 1em;
	}
} */

.app_title {
	padding: 0.2em;
}

.app_header {
	background: #22ABAA;
	padding: 0.4em 0;
	z-index: 1000;
	position: fixed;
	top: 0;
	width: 100%;
	box-shadow: 1px 1px 4px #777;

	.logo_container {
		width: 100%;
		text-align: center;
	}

	.icon_container {
		padding: 0.4em;
		text-align: center;
		cursor: pointer;
		font-size: 1.2em;
	}
}
</style>



// WEBPACK FOOTER //
// src/features/header.vue